import removeMd from "remove-markdown";
import type { Message } from "@/components/feature/layout/types";
import { FileItem, FolderItem } from "@/types/fse";

export const reformatCitations = (text: string): string =>
  text.replace(/\[(\d+(?:,\s*\d+)*)\]/g, (_: string, p1: string) => {
    const citations = p1.split(",").map((num: string) => num.trim());
    return citations
      .map((citation: string) => {
        const citationNumber = parseInt(citation, 10);
        if (isNaN(citationNumber)) {
          return `[${citation}]`;
        } else if (citationNumber === 0) {
          return "[0]";
        } else {
          return `[${citationNumber}]`;
        }
      })
      .join("");
  });

export const removeCitations = (text: string): string => text.replace(/\[(?:Id:)?(\d+(?:,\s*(?:Id:)?\d+)*)\]/g, "");

const extractItemList = (rootItem: FileItem | FolderItem, result: Record<string, string> = {}) => {
  if (rootItem.type === "folder" && typeof rootItem.items !== "undefined") {
    Object.entries(rootItem.items).forEach(([, item]) => {
      result[item.id] = item.name;
      if (item.type === "folder") {
        return extractItemList(item, result);
      }
    });
  } else {
    result[rootItem.id] = rootItem.name;
  }
  return result;
};

const removeDuplicateParentheses = (text: string) => text.replace(/\(([^)]+)\)\s*\(\1\)/g, "($1)");

export const extractCitation = (message: Message, rootItem: FileItem | FolderItem): string => {
  const items = extractItemList(rootItem);

  const replaceCitation = (match: string) => {
    const citationIds = match.slice(1, -1).split(",");

    const citation = message.evidences
      .filter(evidence => citationIds.includes(evidence.citationId))
      .map(evidence => {
        const document = items[evidence.fseId];

        if (!evidence.highlights.length) {
          return "";
        }
        const page = evidence.highlights[0].page + 1;

        return `p.${page}, ${document || ""}`;
      })
      .filter(Boolean);

    const deduplicatedCitation = [...new Set(citation)];

    return ` (${deduplicatedCitation.join(", ")})`;
  };

  const result = message.content
    .replace(/\[\d+(,\d+)*\]/g, replaceCitation)
    .replace(/\[([\w\-\s,]+)\]/g, replaceCitation);

  return removeDuplicateParentheses(result);
};

export const removeMarkdown = (text: string): string => removeMd(text);
